import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from 'formlabs-web-components/Form';

import { getStates } from './SelectOptions';

const StateSelect = ({ ...props }) => {
  const { t } = useTranslation();

  return (
    <Select {...props}>
      <option value="">– {t('Select')} –</option>
      {getStates(t).map(state => (
        <option key={state.value} value={state.value}>
          {t(state.text)}
        </option>
      ))}
    </Select>
  );
};

StateSelect.defaultProps = { defaultValue: '' };
export default StateSelect;
